/**
 * Internationalization Configuration
 */

export const locales = ['en', 'nl', 'de'] as const;
export type Locale = typeof locales[number];

export const defaultLocale: Locale = 'en';

export const localeNames: Record<Locale, string> = {
  en: 'English',
  nl: 'Nederlands',
  de: 'Deutsch',
};

export const localeFlags: Record<Locale, string> = {
  en: '🇬🇧',
  nl: '🇳🇱',
  de: '🇩🇪',
};

/**
 * Get locale-specific path
 * English (default) doesn't get a prefix, other languages do
 */
export function getLocalePath(locale: Locale, path: string = ''): string {
  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  // English is at root, other languages get prefix
  if (locale === defaultLocale) {
    return cleanPath;
  }
  return `/${locale}${cleanPath === '/' ? '' : cleanPath}`;
}

/**
 * Check if locale is valid
 */
export function isValidLocale(locale: string): locale is Locale {
  return locales.includes(locale as Locale);
}
